(function () {
  'use strict';

  function initialize(section) {
    if (section.dataset.ssInitialized === 'true') return;
    const source = section.querySelector('[data-ss-product-data]');
    const form = section.querySelector('.ss-native-product-form');
    const variantSelect = section.querySelector('[data-ss-variant-select]');
    if (!source || !form || !variantSelect) return;

    let data;
    try { data = JSON.parse(source.textContent); } catch (_) { return; }
    if (!Array.isArray(data.variants) || !data.variants.length) return;

    const variants = data.variants;
    const strings = data.strings || {};
    const picker = section.querySelector('[data-ss-option-picker]');
    const fallback = section.querySelector('[data-ss-variant-fallback]');
    const buttons = Array.from(section.querySelectorAll('[data-ss-option-index]'));
    const add = section.querySelector('[data-ss-add]');
    const addLabel = section.querySelector('[data-ss-add-label]');
    const price = section.querySelector('[data-ss-product-price]');
    const skuLine = section.querySelector('[data-ss-product-sku]');
    const skuValue = section.querySelector('[data-ss-product-sku-value]');
    const description = section.querySelector('[data-ss-variant-description]');
    const availability = section.querySelector('[data-ss-availability]');
    const panelRow = section.querySelector('[data-ss-panel-check]');
    const panelConfirmation = section.querySelector('[data-ss-panel-confirmation]');
    const quantity = section.querySelector('[data-ss-quantity]');
    const error = section.querySelector('[data-ss-product-error]');
    const mainImage = section.querySelector('[data-ss-main-image]');
    const gallery = section.querySelector('[data-ss-gallery]');
    const facts = section.querySelector('[data-ss-current-facts]');
    const paymentOptions = section.querySelector('[data-ss-payment-options]');
    const galleryButtons = Array.from(section.querySelectorAll('[data-ss-gallery-image]'));
    const queryId = new URL(window.location.href).searchParams.get('variant');
    let selected = variants.find(function (v) { return String(v.id) === queryId; }) ||
      variants.find(function (v) { return String(v.id) === String(data.selectedVariantId); }) || variants[0];
    let selectedOptions = selected.options.slice();

    function showError(message) {
      if (!error) return;
      error.textContent = message || '';
      error.hidden = !message;
    }

    function updateImage(image) {
      if (!image || !mainImage) return;
      mainImage.removeAttribute('srcset');
      mainImage.src = image.src;
      mainImage.alt = image.alt || data.productTitle;
      if (image.width) mainImage.width = image.width;
      if (image.height) mainImage.height = image.height;
      galleryButtons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.ssGalleryImage === image.src));
      });
    }

    function updateSubmit() {
      const needsConfirmation = selected && selected.needsPanelConfirmation;
      const confirmationMissing = needsConfirmation && (!panelConfirmation || !panelConfirmation.checked);
      if (add) add.disabled = !selected || !selected.available || confirmationMissing;
      if (addLabel) addLabel.textContent = selected && selected.available ? strings.addToCart : strings.unavailable;
    }

    function updateQuantityRule(variant) {
      if (!quantity || !variant) return;
      const minimum = Number(variant.quantityMin) || 1;
      const increment = Number(variant.quantityIncrement) || 1;
      const maximum = variant.quantityMax == null ? null : Number(variant.quantityMax);
      quantity.min = String(minimum);
      quantity.step = String(increment);
      if (maximum != null) quantity.max = String(maximum); else quantity.removeAttribute('max');
      let amount = Number(quantity.value);
      if (!Number.isFinite(amount) || amount < minimum) amount = minimum;
      amount = minimum + Math.ceil((amount - minimum) / increment) * increment;
      if (maximum != null && amount > maximum) amount = minimum + Math.floor((maximum - minimum) / increment) * increment;
      quantity.value = String(amount);
      quantity.setCustomValidity('');
    }

    function updateUrl(variant) {
      const url = new URL(window.location.href);
      if (variant) url.searchParams.set('variant', String(variant.id)); else url.searchParams.delete('variant');
      try { window.history.replaceState(window.history.state, '', url.toString()); } catch (_) {}
    }

    function updateFacts(variant) {
      if (!facts) return;
      if (!variant) {
        facts.textContent = strings.unavailableCombination;
        facts.dataset.ssFactsVariantId = '';
        return;
      }
      if (facts.dataset.ssFactsVariantId === String(variant.id)) return;
      const template = section.querySelector('template[data-ss-facts-variant="' + variant.id + '"]');
      if (template) {
        facts.replaceChildren(template.content.cloneNode(true));
        facts.dataset.ssFactsVariantId = String(variant.id);
      }
    }

    function update(shouldUpdateUrl, shouldUpdateImage) {
      selected = variants.find(function (variant) {
        return variant.options.every(function (value, index) { return value === selectedOptions[index]; });
      }) || null;
      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.optionValue === selectedOptions[Number(button.dataset.ssOptionIndex)]));
      });
      variantSelect.value = selected ? String(selected.id) : '';
      variantSelect.disabled = !selected;
      if (price) price.textContent = selected ? selected.priceFormatted : '—';
      if (skuLine) {
        const sku = selected && selected.sku ? String(selected.sku).trim() : '';
        if (skuValue) skuValue.textContent = sku;
        skuLine.hidden = !sku;
      }
      if (paymentOptions) paymentOptions.hidden = !selected || !selected.available;
      if (description) description.textContent = selected ? (data.hasOnlyDefaultVariant ? data.productTitle : selected.title) : selectedOptions.join(' / ');
      if (availability) {
        availability.hidden = Boolean(selected && selected.available);
        availability.textContent = selected ? strings.unavailable : strings.unavailableCombination;
      }
      const requiresPanel = Boolean(selected && selected.needsPanelConfirmation);
      if (panelRow) panelRow.hidden = !requiresPanel;
      if (panelConfirmation) {
        panelConfirmation.required = requiresPanel;
        panelConfirmation.disabled = !requiresPanel;
        if (!requiresPanel) panelConfirmation.checked = false;
        panelConfirmation.setCustomValidity('');
      }
      updateQuantityRule(selected);
      updateFacts(selected);
      if (shouldUpdateImage && selected) updateImage(selected.image);
      if (shouldUpdateUrl) updateUrl(selected);
      showError('');
      updateSubmit();
    }

    section.addEventListener('click', function (event) {
      const option = event.target.closest('[data-ss-option-index]');
      if (option && section.contains(option)) {
        if (selectedOptions[Number(option.dataset.ssOptionIndex)] === option.dataset.optionValue) return;
        selectedOptions[Number(option.dataset.ssOptionIndex)] = option.dataset.optionValue;
        if (panelConfirmation) panelConfirmation.checked = false;
        update(true, true);
        return;
      }
      const imageButton = event.target.closest('[data-ss-gallery-image]');
      if (imageButton && section.contains(imageButton)) {
        updateImage({ src: imageButton.dataset.ssGalleryImage, alt: imageButton.dataset.imageAlt, width: Number(imageButton.dataset.imageWidth), height: Number(imageButton.dataset.imageHeight) });
      }
    });

    variantSelect.addEventListener('change', function () {
      const variant = variants.find(function (v) { return String(v.id) === variantSelect.value; });
      if (!variant) return;
      selectedOptions = variant.options.slice();
      if (panelConfirmation) panelConfirmation.checked = false;
      update(true, true);
    });

    if (panelConfirmation) panelConfirmation.addEventListener('change', function () {
      panelConfirmation.setCustomValidity('');
      showError('');
      updateSubmit();
    });

    if (quantity) quantity.addEventListener('input', function () { quantity.setCustomValidity(''); });

    form.addEventListener('submit', function (event) {
      if (!selected || !selected.available) {
        event.preventDefault();
        showError(selected ? strings.unavailable : strings.chooseVariant);
        return;
      }
      if (selected.needsPanelConfirmation && (!panelConfirmation || !panelConfirmation.checked)) {
        event.preventDefault();
        showError(strings.confirmPanel);
        if (panelConfirmation) {
          panelConfirmation.setCustomValidity(strings.confirmPanel);
          panelConfirmation.reportValidity();
        }
        return;
      }
      if (quantity && !quantity.checkValidity()) {
        event.preventDefault();
        showError(strings.quantityInvalid);
        quantity.reportValidity();
        return;
      }
      variantSelect.value = String(selected.id);
      variantSelect.disabled = false;
      if (section.dataset.cartAddUrl) form.action = section.dataset.cartAddUrl;
    });

    if (picker) picker.hidden = false;
    if (fallback) fallback.hidden = true;
    if (gallery) gallery.hidden = false;
    section.dataset.ssInitialized = 'true';
    update(false, false);
  }

  function initializeWithin(scope) {
    if (scope.matches && scope.matches('[data-ss-native-product]')) initialize(scope);
    scope.querySelectorAll('[data-ss-native-product]').forEach(initialize);
  }

  initializeWithin(document);
  document.addEventListener('shopify:section:load', function (event) { initializeWithin(event.target); });
}());
